/* eslint react-hooks/exhaustive-deps: 0 */
import React from "react";
import { useHistory } from "react-router-dom";
import DataTable from "react-data-table-component";
import axios from "axios";
import _ from "lodash";
import { DEVICE_SERVICE_URL, VW_ROUTES, apiRoutes } from "../../constants";
import ProfileCard from "../../components/ProfileCard/ProfileCard";
import useState from "react-usestateref";
import { AppContext } from "../../context/AppContext";
import {
  checkModuleViewPermission,
  formatTextWithFallback,
  getCategoryType,
  getFormattedDateTime,
} from "../../helpers/helpers";
import SearchBar from "../../components/common/Search/Search";
// import ExportButton from "../../components/common/Export/Export";
import LivePeopleExpandable from "../../components/common/TableExpandableComponent/LivePeopleExpandable";
import SelectApplicants from "../../components/common/SelectApplicants/SelectApplicants";
import { useLocation } from "react-router-dom/cjs/react-router-dom.min";
import useStorage from "../../helpers/useStorage";
import LazyLoadedSelect from "../../components/LazyLoadedSelect/LazyLoadedSelect";
import useSiteOptions from "../../components/common/CommonDeliverables/useSiteOptions";
import {
  defaultSelectOption,
  formatValueWithDefaultOption,
  selectOptionsDefaultOptionAppender,
} from "../../helpers/utils";
const LivePeopleListComponent = ({ location }) => {
  const { setToStorage, getFromStorage, removeFromStorage } = useStorage();
  const {
    sites,
    loadNextSiteOptionsPage,
    handleSiteSearch,
    isSiteLoading,
    hasError,
  } = useSiteOptions();
  const [isLoading, setIsLoading] = React.useState(true);
  const {
    userRoleDetails,
    appOptions,
    getCategoryFromSlug,
    currentUser,
    manageLoader,
  } = React.useContext(AppContext);
  const [currentPageNumber, setCurrentPageNumber] = React.useState(1);
  const [updateKey, setUpdateKey] = React.useState(0);
  const [resetPagination, setResetPagination] = React.useState(false);
  const [rowsPerPage, setRowsPerPage] = React.useState();
  const [totalEntries, setTotalEntries] = React.useState(0);
  const [markerId, setMarkerId] = React.useState("");
  // const [pageAction, setPageAction] = React.useState("first");
  const [pageNumber, setPageNumber] = React.useState(1);

  const [searchQueryString, setSearchQueryString, searchQueryStringRef] =
    useState();
  const [filterCategory, setFilterCategory] = React.useState();
  const [filtersite, setFilterSite] = React.useState();

  // URL-based parameters (determine page type - from query strings)
  const [urlSite, setUrlSite] = React.useState();
  const [urlContract, setUrlContract] = React.useState();
  const [urlCompany, setUrlCompany] = React.useState();

  const [category, setCategory] = React.useState();
  const [site, setSite] = React.useState(); // Applied site filter
  const [filterApplied, setFilterApplied] = React.useState(false);

  const [personData, setpersonData] = React.useState([]);
  const token = localStorage.getItem("access_token");

  const [exportData, setExportData] = React.useState("");
  const [disableExport, setdisableExport] = React.useState(true);

  const [showMobileDataFilter, setShowMobileDataFilter] = React.useState(false);

  const [showSuccessModal, setShowSuccessModal] = React.useState(false);
  const [showSuccessMessage, setShowSuccessMessage] = React.useState("");

  const history = useHistory();
  //const location = useLocation();

  const filterTypes = {
    ["live-people"]: "live",
    ["over-stay-people"]: "over_stay",
  };

  const filterNames = {
    ["live-people"]: "Live",
    ["over-stay-people"]: "Over Stay",
  };

  let filterType = filterTypes[location.pathname.split("/")[1]];

  const getPageTitle = () => {
    if (urlContract)
      return `Contract Based ${
        filterNames[location.pathname.split("/")[1]]
      } People Listing`;
    else if (String(urlCompany ?? "").length)
      return `Company Based ${
        filterNames[location.pathname.split("/")[1]]
      } People Listing`;
    else if (String(urlSite ?? "").length)
      return `Site Based ${
        filterNames[location.pathname.split("/")[1]]
      } People Listing`;
    else
      return `${filterNames[location.pathname.split("/")[1]]} People Listing`;
  };

  const liveFilterType = () => {
    if (urlContract) return "contract";
    else if (String(urlCompany ?? "").length) return "company";
    else if (String(urlSite ?? "").length) return "site";
    else return "";
  };

  const getLivePeoplePrimaryProperty = () => {
    switch (liveFilterType()) {
      case "contract":
        return "contract";
      case "company":
        return "company";
      case "site":
        return "site";
      default:
        return "contract";
    }
  };

  const getLivePeopleSecondaryProperty = () => {
    switch (liveFilterType()) {
      case "contract":
        return "company";
      case "company":
        return "contract";
      case "site":
        return "site";
      default:
        return "company";
    }
  };

  React.useEffect(() => {
    setRowsPerPage(
      getFromStorage(`${_.snakeCase(getPageTitle())}_rows_per_page`) ?? 10,
    );
    setSearchQueryString(
      getFromStorage(`${_.snakeCase(getPageTitle())}_filter_search`) ?? "",
    );
    setFilterCategory(
      getFromStorage(`${_.snakeCase(getPageTitle())}_filter_category`) ?? "",
    );
    // Don't initialize filtersite from storage - it will be set when modal opens

    setCategory(
      getFromStorage(`${_.snakeCase(getPageTitle())}_filter_category`) ?? "",
    );
    setSite(getFromStorage(`${_.snakeCase(getPageTitle())}_filter_site`) ?? "");
  }, []);

  React.useEffect(() => {
    if (!String(location.search ?? "").length) {
      // Clear URL params if no search query
      setUrlCompany("");
      setUrlContract("");
      setUrlSite("");
      return;
    }

    const searchParams = new URLSearchParams(location.search);
    const contractFromURL = searchParams.get("contract");
    const companyFromURL = searchParams.get("company");
    const siteFromURL = searchParams.get("site");

    setUrlCompany("");
    setUrlContract("");
    setUrlSite("");

    if (contractFromURL) setUrlContract(contractFromURL);
    else if (companyFromURL) setUrlCompany(companyFromURL);
    else if (siteFromURL) setUrlSite(siteFromURL);
  }, [location.search]);

  const getCellCategoryType = (cellProfile) =>
    getCategoryType(
      getCategoryFromSlug(
        String(cellProfile?.category ?? "").toLowerCase(),
        appOptions,
      )?.slug,
    );

  const axiosOptions = (method, url) => {
    return {
      method,
      headers: {
        "content-type": "application/x-www-form-urlencoded",
        Authorization: `JWT ${token}`,
      },
      url: `${DEVICE_SERVICE_URL}/${url}`,
    };
  };

  const hasLoadedInitialSitesRef = React.useRef(false);

  React.useEffect(() => {
    if (!showMobileDataFilter) {
      hasLoadedInitialSitesRef.current = false;
    } else {
      // Set filter values when opening - use the applied filter values
      setFilterCategory(category);
      setFilterSite(site);
    }
  }, [showMobileDataFilter]);

  // Reset the flag when filter is closed
  React.useEffect(() => {
    if (!showMobileDataFilter) {
      hasLoadedInitialSitesRef.current = false;
    }
  }, [showMobileDataFilter]);

  const handleResetFilter = () => {
    setFilterApplied(false);
    // setPageAction("first");
    setPageNumber(1);
    setMarkerId("");
    setCurrentPageNumber(1);
    setResetPagination(true);
    setCategory("");
    setSite("");
    setFilterSite("");
    setFilterCategory("");
    removeFromStorage();
    showFilter(false);
  };

  const handleApplyFilter = () => {
    // setPageAction("first");
    setMarkerId("");
    setCurrentPageNumber(1);
    setPageNumber(1);
    setResetPagination(true);
    setCategory(filterCategory ?? "");
    setSite(filtersite ?? ""); // Apply the site filter from dropdown
    // Note: We don't update any URL-based state here, only filter state
    setToStorage({
      [`${_.snakeCase(getPageTitle())}_filter_category`]: filterCategory,
      [`${_.snakeCase(getPageTitle())}_filter_site`]: filtersite,
      [`${_.snakeCase(getPageTitle())}_page_no`]: 1,
    });
    showFilter(false);
  };

  const handleCategoryFilterChange = (e) => {
    setFilterCategory(e);
  };

  const handleSiteChange = (e) => {
    setFilterSite(e);
  };

  const jumpToFirstPage = () => {
    setResetPagination(true);
    // setPageAction("first");
    setMarkerId("");
    setPageNumber(1);
  };
  const handleUpdateKey = () => {
    setUpdateKey((k) => k + 1);
  };
  React.useEffect(() => {
    if (personData?.length > 0) {
      setdisableExport(false);
    } else {
      setdisableExport(true);
    }
  }, [personData]);

  const viewDetails = (applicantData) => {
    history.push({
      pathname: VW_ROUTES.PERSON_PROFILE_VIEW,
      search: `?id=${applicantData?.person_id}`,
      state: {
        from: String(history.location?.pathname ?? ""),
      },
    });
  };
  const getEvent = (mode) => {
    if (mode.mode === "view") {
      viewDetails(mode?.applicant);
    }
  };
  const doFilter = (pageNumber) => {
    setIsLoading(true);
    setResetPagination(false);
    if (!String(filterType ?? "").length || !String(rowsPerPage ?? "").length)
      return;

    if (String(category?.value ?? "").length) setFilterApplied(true);
    if (String(site?.value ?? "").length) setFilterApplied(true);
    else if (!String(category?.value ?? "").length) setFilterApplied(false);

    const filterParams = new URLSearchParams();
    filterParams.append("module", filterType);
    if (String(searchQueryString ?? "").length)
      filterParams.append("search", searchQueryString);
    if (String(category?.value ?? "").length)
      filterParams.append("category", category?.label);
    if (String(site?.value ?? "").length)
      filterParams.append("site_id", site?.value);

    // Use URL-based params for contract/company/site context
    if (String(urlContract ?? "").length)
      filterParams.append("contract_id", urlContract);
    else if (String(urlCompany ?? "").length)
      filterParams.append("company_id", urlCompany);
    else if (String(urlSite ?? "").length)
      filterParams.append("site_id", urlSite);

    const filter = filterParams.toString();
    setExportData(filter);
    axios(
      axiosOptions(
        "GET",
        `acs/events?page_number=${pageNumber}&page_size=${rowsPerPage}&${filter}`,
      ),
    )
      .then((response) => {
        setIsLoading(false);
        const {
          data: { data: personData, total: totalEntries },
        } = response;
        setpersonData(personData);
        setTotalEntries(totalEntries);
      })
      .catch((err) => {
        setIsLoading(false);
      });
  };

  React.useEffect(() => {
    doFilter(currentPageNumber);
  }, [
    rowsPerPage,
    // pageAction,
    pageNumber,
    updateKey,
    category,
    site,
    searchQueryString,
    urlContract,
    urlCompany,
    urlSite,
  ]);

  const customStyles = {
    headCells: {
      style: {
        fontWeight: "bold",
        fontSize: "14px",
      },
    },
  };

  const columns = [
    {
      name: "Full Name",
      selector: (person) => person?.personName,
      sortable: true,
      minWidth: 250,
      cell: (applicant) => (
        <ProfileCard
          data={applicant}
          primaryProperty={getLivePeoplePrimaryProperty()}
          mode={"peopleLive"}
          actions={userRoleDetails}
          actionsToParent={(mode) => getEvent({ mode, applicant })}
          cellMode={getCellCategoryType(applicant)}
        />
      ),
    },
    {
      name: "Category",
      sortable: false,
      hide: "md",
      minWidth: 200,
      cell: (applicant) => (
        <span className="text-capitalize">
          {formatTextWithFallback(
            _.replace(applicant?.category ?? "", "_", " "),
          )}
        </span>
      ),
    },
    !getPageTitle().includes("Site") && {
      name: "Site",
      sortable: false,
      hide: "md",
      minWidth: 200,
      cell: (applicant) => (
        <span className="text-capitalize">
          {formatTextWithFallback(_.replace(applicant?.site ?? "", "_", " "))}
        </span>
      ),
    },
    {
      name: _.capitalize(getLivePeoplePrimaryProperty()),
      sortable: false,
      left: true,
      minWidth: "200px",
      selector: (person) => person?.[getLivePeoplePrimaryProperty()],
      hide: "md",
      cell: (applicant) => (
        <>
          <span className="text-uppercase">
            {formatTextWithFallback(
              applicant?.[getLivePeoplePrimaryProperty()],
            )}
          </span>
        </>
      ),
    },
    {
      name: "Event Time",
      minWidth: 200,
      hide: "md",
      cell: (applicant) => (
        <span className="text-left">{`${getFormattedDateTime(
          applicant?.event_time,
        )}`}</span>
      ),
    },
    {
      name: "Actions",
      minWidth: 100,
      maxWidth: 100,
      hide: "md",
      sortable: false,
      cell: (applicant) => (
        <>
          {checkModuleViewPermission(
            userRoleDetails,
            getCellCategoryType(applicant),
            "profile",
            applicant,
          ) && (
            <span
              className="simple-icon-eye user-role-action-icons view"
              onClick={() => viewDetails(applicant)}
            ></span>
          )}
        </>
      ),
      center: true,
    },
  ];

  const onChangePage = (page) => {
    // let pageActionType = currentPageNumber > page ? "previous" : "next";

    // if (page - 1 === currentPageNumber) {
    //   pageActionType = "next";
    // } else {
    //   if (page === 1) {
    //     pageActionType = "first";
    //   } else if (page === Math.ceil(totalEntries / rowsPerPage)) {
    //     pageActionType = "last";
    //   }
    // }
    // setPageAction(pageActionType);
    // const currentMarkerId =
    //   pageActionType === "next"
    //     ? personData[personData.length - 1]._id.$oid
    //     : personData[0]._id.$oid;
    // setMarkerId(currentMarkerId);
    doFilter(page);
    setCurrentPageNumber(page);
  };

  const onSearchInputChange = (searchQuery) => {
    setSearchQueryString(searchQuery);
    setToStorage(
      {
        [`${_.snakeCase(getPageTitle())}_filter_search`]: filterCategory,
      },
      true,
    );
  };

  const onChangeRowsPerPage = (rows) => {
    setToStorage(
      { [`${_.snakeCase(getPageTitle())}_rows_per_page`]: rows },
      true,
    );
    removeFromStorage(`${_.snakeCase(getPageTitle())}_page_no`, "onlyThis");
    setRowsPerPage(rows);
  };

  const onExport = () => {
    manageLoader(true);
    const options = {
      method: "GET",
      headers: {
        "content-type": "application/json",
        Authorization: `JWT ${token}`,
      },
      url: `${apiRoutes.acsTransactionExport}?${exportData}`,
    };
    axios(options)
      .then((response) => {
        manageLoader(false);
        setShowSuccessModal(true);
        setShowSuccessMessage(response.data.data.message);
      })
      .finally(() => manageLoader(false));
  };

  const closeExportSuccessModal = () => {
    setShowSuccessModal(false);
    setShowSuccessMessage("");
  };

  const showFilter = (mode) => {
    setShowMobileDataFilter(mode);
  };

  return (
    <>
      <div className="row">
        <div className="col-12">
          <div className="page-header withExport">
            <h1>{getPageTitle()}</h1>
            <div className="applicantFilter">
              <div className="desktopSearch">
                <SearchBar
                  onSearchInputChange={onSearchInputChange}
                  popstateText={searchQueryString}
                />
              </div>
              <div
                className={
                  showMobileDataFilter ? "table-filter active" : "table-filter"
                }
              >
                <div
                  className="filter-hide"
                  onClick={() => showFilter(false)}
                ></div>
                <div className="filter-form">
                  <h4 className="advanced-filter-heading">Advanced Search</h4>
                  <div>
                    <div className="advance-filter">
                      <div>
                        <span>Category</span>
                        <div className="mb-2">
                          <SelectApplicants
                            searchByApplicantType={handleCategoryFilterChange}
                            applicantType={filterCategory}
                          />
                        </div>
                      </div>
                      {showMobileDataFilter &&
                        !getPageTitle().includes("Site") && (
                          <div>
                            <span>Site</span>
                            <LazyLoadedSelect
                              className="cutomSelect"
                              classNamePrefix="react-select"
                              loadNextOptions={loadNextSiteOptionsPage}
                              name="site"
                              onChange={(opt) =>
                                handleSiteChange({
                                  name: "site",
                                  value: opt?.value,
                                  label: opt?.label,
                                })
                              }
                              onInputChange={(value) => handleSiteSearch(value)}
                              options={selectOptionsDefaultOptionAppender(
                                sites,
                                true,
                              )}
                              placeholder="Select"
                              value={formatValueWithDefaultOption(filtersite)}
                              isLoading={isSiteLoading}
                              isClearable={true}
                              defaultValue={defaultSelectOption()}
                            />
                          </div>
                        )}
                    </div>

                    <div className="d-flex w-100 align-items-center justify-content-end mt-3">
                      <button
                        className="btn btn-primary mr-2"
                        onClick={() => {
                          handleResetFilter();
                        }}
                      >
                        Reset
                      </button>
                      <button
                        className="btn btn-secondary m-0"
                        onClick={() => {
                          handleApplyFilter();
                        }}
                      >
                        Apply
                      </button>
                    </div>
                  </div>
                </div>
              </div>
              <button
                className="btn btn-secondary ml-2"
                onClick={onExport}
                disabled={disableExport}
              >
                Export
              </button>
              <div
                className={`tableFilterButton rightAlign ml-2  ${
                  filterApplied ? "btn-secondary" : ""
                }`}
                title="Advance Search"
                onClick={() => showFilter(true)}
              >
                <i className="iconsminds-filter-2"></i>
              </div>
            </div>{" "}
          </div>
        </div>
      </div>
      <div className="row">
        <div className="col-lg-12 col-md-12 mb-4">
          <div className="card">
            <div
              className={
                isLoading
                  ? "card-body dataTableOuter cmpnyTable table-loader"
                  : "card-body dataTableOuter cmpnyTable"
              }
            >
              <DataTable
                subHeader={true}
                //subHeaderComponent={<> <button className="btn btn-primary">Export</button><SearchBar onSearchInputChange={onSearchInputChange} /></>}
                progressPending={isLoading}
                progressComponent={<p>&nbsp;</p>}
                columns={columns}
                data={personData}
                customStyles={customStyles}
                paginationServer={true}
                striped={true}
                onChangePage={onChangePage}
                onChangeRowsPerPage={onChangeRowsPerPage}
                pagination={true}
                paginationPerPage={rowsPerPage}
                paginationTotalRows={totalEntries}
                paginationResetDefaultPage={resetPagination}
                expandableRows
                expandableRowsComponent={(props) => (
                  <LivePeopleExpandable
                    data={{ ...props }}
                    secondaryProperty={getLivePeopleSecondaryProperty}
                  />
                )}
              />
            </div>
          </div>
        </div>
      </div>
      <div className={`reportStatusPopup ${showSuccessModal ? "show" : ""}`}>
        <div className="popUp">
          <div className="content">{showSuccessMessage}</div>
          <div className="action">
            <button
              className="btn btn-secondary"
              onClick={closeExportSuccessModal}
            >
              OK
            </button>
          </div>
        </div>
      </div>
    </>
  );
};

export default LivePeopleListComponent;
